import { useUploaderUploadConfigQuery } from './__gql/useUploadInfo.gql.gen';

export const useUploadInfo = (
  projectId: string,
): {
  uploadUrl?: string;
  uploadHeader?: string;
} => {
  const { data, loading, error } = useUploaderUploadConfigQuery({
    variables: { projectId },
  });

  if (loading || error) {
    return {};
  }
  if (!data?.currentContact?.granaryConfig) {
    return {};
  }

  const {
    currentContact: {
      expiringToken,
      granaryConfig: {
        uploadUrl,
        credentials: { uploadAuthParam },
      },
    },
  } = data;

  const uploadHeader = uploadAuthParam ?? `Bearer ${expiringToken}`;

  return { uploadUrl, uploadHeader };
};
